import React from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import qs from "query-string"
import AppRouter from "./app"
import { touchSupport } from "./common/common"
import { loadCSS } from "fg-loadcss"
import store from "./redux/store"
import ThemeProvider from "./common/theme/Provider"
import { STATIC_URL, SENTRY_RELEASE, ENVIRONMENT } from "./common/constants"
import * as Sentry from "@sentry/browser"
import captureInstallPrompt from "./common/captureInstallPrompt"
import { ConnectedIntlProvider } from "./locales/ConnectedIntlProvider"

// Polyfill to allow intl-pluralrules to be supported on IE11 and Safari
import '@formatjs/intl-pluralrules/polyfill'
import '@formatjs/intl-pluralrules/dist/locale-data/en' // locale-data for en
import '@formatjs/intl-pluralrules/dist/locale-data/es' // locale-data for es

loadCSS(`${STATIC_URL}css/MyFontsWebfontsKit/MyFontsWebfontsKit.css`)
Sentry.init({
  dsn: "https://8174b7cb47ed411b89d86aafe3ca9f20@sentry.io/164479",
  // project@version tag
  release: SENTRY_RELEASE,
  // An environment identifier.
  environment: ENVIRONMENT,
})

const query = qs.parse(window.location.search)
if (query.search_first) {
  window.search_first_ab_test = true
}

if (!touchSupport()) {
  document.documentElement.className += " non-touch"
}

// Attaches beforeinstallprompt event listener to window, stores captured event in
// window.deferredInstallPrompt which can be used to trigger PWA install prompt.
captureInstallPrompt()

ReactDOM.render(
  <Provider store={store}>
    <ConnectedIntlProvider>
      <ThemeProvider>
        <AppRouter />
      </ThemeProvider>
    </ConnectedIntlProvider>
  </Provider>,
  document.getElementById("search")
)



// WEBPACK FOOTER //
// ./assets/index.js